/*
Bones Scripts File
Author: Eddie Machado

This file should contain any js scripts you want to add to the site.
Instead of calling it in the header or throwing it inside wp_head()
this file will be called automatically in the footer so as not to
slow the page load.

*/

// IE8 ployfill for GetComputed Style (for Responsive Script below)
if (!window.getComputedStyle) {
  window.getComputedStyle = function(el, pseudo) {
    this.el = el;
    this.getPropertyValue = function(prop) {
      var re = /(\-([a-z]){1})/g;
      if (prop === "float") {
        prop = "styleFloat";
      }
      if (re.test(prop)) {
        prop = prop.replace(re, function() {
          return arguments[2].toUpperCase();
        });
      }
      return el.currentStyle[prop] ? el.currentStyle[prop] : null;
    };
    return this;
  };
}

// as the page loads, call these scripts
jQuery(document).ready(function($) {
  // Add class 'active' to first slide of WPP carousel
  function initiateCarousels() {
    // Show first carousel, all initially hidden
    if ($("#d-bs-carousel").length) {
      var carousels = $("#d-bs-carousel > div");
      carousels.first().removeClass("hidden");
    }

    // Add active to first mostPop item, not possible via wpp parameters
    if ($("#mostPopCarousel").length)
      $("#mostPopCarousel > .carousel-inner div")
        .first()
        .addClass("active");
  }

  // Move Ville Ranta carousel to its own column
  function moveVilleRanta() {
    if (
      $(".d-bs-carousel-ranta").is(":visible") &&
      $("#villeRantaCarousel").length
    )
      $("#villeRantaCarousel")
        .detach()
        .appendTo(".d-bs-carousel-ranta")
        .removeClass("hidden");
  }

  // Alter between visible carousels
  function toggleCarousels() {
    if ($("#d-bs-carousel").length) {
      var carousels = $("#d-bs-carousel > div");
      var visible = "";
      var fq = 10000;
      var timer = setInterval(swapCarousel, fq);

      function swapCarousel() {
        visible = carousels.not(".hidden");
        if (visible.next().length) {
          visible
            .addClass("hidden")
            .next()
            .removeClass("hidden");
        } else {
          visible.addClass("hidden");
          carousels.first().removeClass("hidden");
        }
      }

      // Do not alter when hovering
      carousels.hover(
        function(event) {
          clearInterval(timer);
        },
        function(event) {
          timer = setInterval(swapCarousel, fq);
        }
      );

      // Add touch events to carousels
      $.each(carousels, function(key, value) {
        var hammertime = new Hammer(value);
        hammertime.on("swiperight", function() {
          clearInterval(timer);
          $(value).carousel("prev");
          timer = setInterval(swapCarousel, fq);
        });
        hammertime.on("swipeleft", function() {
          clearInterval(timer);
          $(value).carousel("next");
          timer = setInterval(swapCarousel, fq);
        });
      });
      // Add touch event to Ville Ranta carousel
      var vr = document.getElementById("villeRantaCarousel");
      if (vr) {
        var villerantaHammertime = new Hammer(vr);
        villerantaHammertime.on("swiperight", function() {
          clearInterval(timer);
          $(vr).carousel("prev");
          timer = setInterval(swapCarousel, fq);
        });
        villerantaHammertime.on("swipeleft", function() {
          clearInterval(timer);
          $(vr).carousel("next");
          timer = setInterval(swapCarousel, fq);
        });
      }
    }
  }

  // Add ranking number to most popular posts
  function addRanking() {
    if ($("#mostPopCarousel").length) {
      var rankingSpans = $("#mostPopCarousel .item span");
      rankingSpans.each(function(i) {
        $(this).html(i + 1 + ".");
      });
    }
  }

  // Shorten long titles
  function shortenTitle(strcount, maxcount) {
    if ($(".d-bs-carousel h2").length) {
      var titles = $(".d-bs-carousel h2");
      titles.each(function() {
        var string = $(this).html();
        if (string.length >= maxcount) {
          var shortString =
            $.trim(string)
              .substring(0, strcount)
              .split(" ")
              .slice(0, -1)
              .join(" ") + "...";
          $(this).html(shortString);
        }
      });
    }
  }

  initiateCarousels();
  moveVilleRanta();
  addRanking();
  toggleCarousels();

  /*
  Responsive jQuery is a tricky thing.
  There's a bunch of different ways to handle
  it, so be sure to research and find the one
  that works for you best.
  */

  /* getting viewport width */
  var responsive_viewport = $(window).width();

  /* if is below 481px */
  if (responsive_viewport < 481) {
    shortenTitle(58, 58);
  } /* end smallest screen */

  /* if is larger than 481px */
  if (responsive_viewport > 481) {
    shortenTitle(89, 99);
  } /* end larger than 481px */

  /* if is above or equal to 768px */
  if (responsive_viewport >= 768) {
    /* load gravatars */
    $(".comment img[data-gravatar]").each(function() {
      $(this).attr("src", $(this).attr("data-gravatar"));
    });
  }

  /* off the bat large screen actions */
  if (responsive_viewport > 1030) {
  }

  // add all your scripts here

  /* Looks for rel=popover and rel=tooltip for Bootstrap JS */
  jQuery("a[rel=popover]")
    .popover()
    .click(function(e) {
      e.preventDefault();
    });

  jQuery("a[rel=tooltip]").tooltip();

  // replace pipe with dot in popular posts
  $("#wpp-list").html(function(i, html) {
    return html.replace(/\|/g, "·");
  });
  $("#wpp-footer").html(function(i, html) {
    return html.replace(/\|/g, "·");
  });

  // scale recent posts height according to neighbour height
  $("#wpp-footer > li:odd").each(function() {
    if (
      $(this)
        .prev()
        .height() > $(this).height()
    ) {
      $(this).height(
        $(this)
          .prev()
          .height()
      );
    }
  });
  $("#wpp-footer > li:even").each(function() {
    if (
      $(this)
        .next()
        .height() > $(this).height()
    ) {
      $(this).height(
        $(this)
          .next()
          .height()
      );
    }
  });
}); /* end of as page load scripts */

/*! A fix for the iOS orientationchange zoom bug.
 Script by @scottjehl, rebound by @wilto.
 MIT License.
*/
(function(w) {
  // This fix addresses an iOS bug, so return early if the UA claims it's something else.
  if (
    !(
      /iPhone|iPad|iPod/.test(navigator.platform) &&
      navigator.userAgent.indexOf("AppleWebKit") > -1
    )
  ) {
    return;
  }
  var doc = w.document;
  if (!doc.querySelector) {
    return;
  }
  var meta = doc.querySelector("meta[name=viewport]"),
    initialContent = meta && meta.getAttribute("content"),
    disabledZoom = initialContent + ",maximum-scale=1",
    enabledZoom = initialContent + ",maximum-scale=10",
    enabled = true,
    x,
    y,
    z,
    aig;
  if (!meta) {
    return;
  }

  function restoreZoom() {
    meta.setAttribute("content", enabledZoom);
    enabled = true;
  }

  function disableZoom() {
    meta.setAttribute("content", disabledZoom);
    enabled = false;
  }

  function checkTilt(e) {
    aig = e.accelerationIncludingGravity;
    x = Math.abs(aig.x);
    y = Math.abs(aig.y);
    z = Math.abs(aig.z);
    // If portrait orientation and in one of the danger zones
    if (
      !w.orientation &&
      (x > 7 || (((z > 6 && y < 8) || (z < 8 && y > 6)) && x > 5))
    ) {
      if (enabled) {
        disableZoom();
      }
    } else if (!enabled) {
      restoreZoom();
    }
  }
  w.addEventListener("orientationchange", restoreZoom, false);
  w.addEventListener("devicemotion", checkTilt, false);
})(this);

(function($) {
  if (undefined !== typeof $) {
    $(".popular-posts-block .img-wrap").click(function(e) {
      e.preventDefault();
      var url = $(this)
        .find("a")
        .attr("href");
      if (url) window.open(url, "_self");
    });

    // Some variables that we need to handle scrolling behaviour
    // var nextPreviousVisible = false;
    // var nextPreviousLastPositionTop = 0;
    // var hintVisible = false;

    // If page contains next/previous -element && window width >= 1280 -> enable scroll based functionality
    // var onPostPage = ($('.js-next-previous').length > 0) ? true : false;
    // var windowWidth = parseInt($(window).width(), 10);
    // scrollBehaviour();
    // // listen resize so we can change behaviour dynamically
    // $(window).resize(function() {
    //   windowWidth = parseInt($(window).width(), 10);
    //   scrollBehaviour();
    // });
    //
    // function scrollBehaviour() {
    //
    //   if (windowWidth < 1280 && nextPreviousVisible) {
    //
    //     $(document).off('scroll');
    //     $('.js-next-previous').addClass('hidden');
    //     nextPreviousVisible = false;
    //
    //   } else if (onPostPage && windowWidth >= 1280) {
    //
    //     var postAreaHeight = parseInt($('.js-post-content').height(), 10);
    //     var postAreaFromTop = parseInt($('.js-post-content').offset().top, 10);
    //     var postAreaFullHeightFromTop = postAreaHeight + postAreaFromTop;
    //
    //     $(document).scroll(function() {
    //       var containerTop = parseInt($('.js-end-scroll-top').offset().top, 10);
    //       var windowHeight = parseInt($(window).height(), 10);
    //       var y = parseInt($(this).scrollTop(), 10);
    //       var nextPreviousTop = parseInt($('.js-next-previous').offset().top, 10);
    //       var nextPreviousPositionTop = parseInt($('.js-next-previous').position().top, 10);
    //       var nextPreviousHeight = parseInt($('.js-next-previous').height(), 10);
    //       if ((y + windowHeight) > postAreaFullHeightFromTop * 0.75 && postAreaFullHeightFromTop >= (y + nextPreviousHeight + nextPreviousPositionTop) && containerTop < (y + postAreaFromTop) && !nextPreviousVisible) {
    //         nextPreviousVisible = true;
    //         $('.js-next-previous').removeClass('hidden');
    //         $('.js-next-previous').addClass('scrolling');
    //       } else if (containerTop > (nextPreviousTop + 20) && $('.js-next-previous').hasClass('scrolling')) {
    //         $('.js-next-previous').removeClass('scrolling');
    //         $('.js-next-previous').addClass('hold');
    //       } else if (postAreaFullHeightFromTop <= (y + nextPreviousHeight + nextPreviousPositionTop) && $('.js-next-previous').hasClass('scrolling')) {
    //         nextPreviousLastPositionTop = nextPreviousPositionTop;
    //         $('.js-next-previous').removeClass('scrolling');
    //         $('.js-next-previous').addClass('hold');
    //       } else if (containerTop < (y + 20) && postAreaFullHeightFromTop > (y + nextPreviousHeight + nextPreviousLastPositionTop) && $('.js-next-previous').hasClass('hold')) {
    //         $('.js-next-previous').addClass('scrolling');
    //         $('.js-next-previous').removeClass('hold');
    //         $('.js-next-previous').css('top', '');
    //       } else if ($('.js-next-previous').hasClass('hold')) {
    //         var dynamicTop = (postAreaFullHeightFromTop < (y + nextPreviousHeight + nextPreviousLastPositionTop)) ? postAreaFullHeightFromTop - (y + nextPreviousHeight) : containerTop - y + 20;
    //         $('.js-next-previous').css('top', dynamicTop + 'px');
    //       }
    //       // hint for comments
    //       //   var t = $('.js-comment-feed').parent().offset().top;
    //       //   if ((y + windowHeight) > t && !hintVisible) {
    //       //     hintVisible = true;
    //       //     $('.js-comment-hint').removeClass('hidden');
    //       //     $('.js-comment-hint').addClass('animation');
    //       //     setTimeout(function() {
    //       //       $('.js-comment-hint').addClass('hidden');
    //       //     }, 5000);
    //       //   }
    //     });
    //   }
    // }

    // Dynamic post loading
    var onDynamicPostPage = $(".dynamic-post").length > 0 ? true : false;
    var dynamicPostsEnbled = browser_support_history_api();
    if (onDynamicPostPage && dynamicPostsEnbled) {
      var dynamicPosts = $(".dynamic-post");
      var nextDynamicPostIndex = 0;
      var dynamicPostHeight = 0;
      var dynamicPostFromTop = 0;
      var dynamicPostAreaFullHeight = 0;

      var postAreaHeight = parseInt($(".js-main-post").height(), 10);
      var postAreaFromTop = parseInt($(".js-main-post").offset().top, 10);
      var postAreaFullHeightFromTop = postAreaHeight + postAreaFromTop;
      var currentLocationUrl = window.location.href;
      var postPositionData = {
        default: {
          top: postAreaFullHeightFromTop,
          url: window.location.href,
          title: document.title.split(" -")[0]
        }
      };
      var postIndexTopValues = [];
      var lastScrollTop = 0;
      var showTreshold = parseInt($(window).height() / 2, 10);
      $(window).resize(function() {
        showTreshold = parseInt($(window).height() / 2, 10);
      });
      var st = $(this).scrollTop();
      var windowPositionHeight = $(document).scrollTop() + $(window).height();
      // Add 3 sec interval to check if user is staying at the current "dynamic post" or not and update url/title and send anayltics if is
      window.setInterval(function() {
        var activeIndex = "default";
        var scrollPositionTreshold = windowPositionHeight - showTreshold;
        $.each(postIndexTopValues, function(i, value) {
          if (
            scrollPositionTreshold < value &&
            postPositionData.default.top < scrollPositionTreshold &&
            isNaN(activeIndex)
          ) {
            activeIndex = i;
          } else if (
            scrollPositionTreshold > value &&
            dynamicPosts.length === i + 1
          ) {
            activeIndex = i;
          }
        });
        maybeUpdateCurrentPostState(activeIndex);
      }, 3000);

      $(window).scroll(function() {
        st = $(this).scrollTop();
        windowPositionHeight = $(document).scrollTop() + $(window).height();
        if (dynamicPosts.length >= nextDynamicPostIndex) {
          if (st > lastScrollTop) {
            // downscroll
            if (
              postAreaFullHeightFromTop <=
              windowPositionHeight + showTreshold
            ) {
              $(dynamicPosts[nextDynamicPostIndex]).removeClass("hide");
            }
            if (
              postAreaFullHeightFromTop <=
                windowPositionHeight - showTreshold &&
              nextDynamicPostIndex < dynamicPosts.length
            ) {
              dynamicPostHeight = parseInt(
                $(dynamicPosts[nextDynamicPostIndex]).height(),
                10
              );
              dynamicPostFromTop = parseInt(
                $(dynamicPosts[nextDynamicPostIndex]).offset().top,
                10
              );
              postAreaFullHeightFromTop =
                dynamicPostHeight + dynamicPostFromTop;
              var dynamicUrl = $(dynamicPosts[nextDynamicPostIndex]).data(
                "url"
              );
              var dynamicTitle = $(dynamicPosts[nextDynamicPostIndex]).data(
                "title"
              );
              postPositionData[nextDynamicPostIndex] = {
                top: postAreaFullHeightFromTop,
                url: dynamicUrl,
                title: dynamicTitle
              };
              postIndexTopValues[
                nextDynamicPostIndex
              ] = postAreaFullHeightFromTop;
              if (dynamicPosts.length > nextDynamicPostIndex)
                nextDynamicPostIndex++;
            }
          } else {
            // upscroll
            if (
              (nextDynamicPostIndex > 0 &&
                st <=
                  postPositionData[nextDynamicPostIndex - 1].top -
                    showTreshold) ||
              (nextDynamicPostIndex === 0 &&
                st > postPositionData["default"].top)
            ) {
              if (nextDynamicPostIndex > 0) nextDynamicPostIndex--;
              dynamicPostHeight = parseInt(
                $(dynamicPosts[nextDynamicPostIndex]).height(),
                10
              );
              dynamicPostFromTop = parseInt(
                $(dynamicPosts[nextDynamicPostIndex]).offset().top,
                10
              );
              postAreaFullHeightFromTop = postAreaHeight + postAreaFromTop;
            } else if (
              postPositionData["default"].url !== window.location.href &&
              nextDynamicPostIndex === 0 &&
              st <= postPositionData[nextDynamicPostIndex].top
            ) {
              postAreaFullHeightFromTop = postAreaHeight + postAreaFromTop;
            }
          }
          lastScrollTop = st;
        }
      });
    }

    function maybeUpdateCurrentPostState(activeIndex) {
      if (currentLocationUrl !== postPositionData[activeIndex].url) {
        currentLocationUrl = postPositionData[activeIndex].url;
        push_state(
          {},
          postPositionData[activeIndex].title,
          postPositionData[activeIndex].url
        );
        set_title(postPositionData[activeIndex].title);
        send_ga_page_view();
      }
    }

    function push_state(state, title, url) {
      if (typeof history !== "undefined" && window.location.href != url) {
        history.pushState(state, title, url);
      }
    }

    function send_ga_page_view() {
      if (typeof ga === "function") {
        // Add default value if for some reason d_current_category.name isn't defined
        var dimensionValue =
          typeof d_current_category != "undefined" &&
          typeof d_current_category.name == "string"
            ? d_current_category.name
            : "Politiikka";
        ga("send", {
          hitType: "pageview",
          page: window.location.pathname,
          dimension1: dimensionValue
        });
      }
    }

    function set_title(title) {
      if (title + " - Demokraatti.fi" != document.title) {
        document.title = title + " - Demokraatti.fi";
      }
    }

    function browser_support_history_api() {
      return typeof history !== "undefined";
    }

    // Demokraatti Hamburger menu
    var deviceWidth = parseInt($(window).width(), 10);
    $(window).resize(function() {
      deviceWidth = parseInt($(window).width(), 10);
    });

    $("#d-menu-trigger").click(navclick);
    var menuTop = 0;
    function navclick() {
      // Try to keep body position during menu open/close
      if ($("#d-menu-trigger").hasClass("open")) {
        $("body").removeClass("noscroll");
        if (deviceWidth <= 768) {
          $("body").css("top", "");
          $(document).scrollTop(menuTop);
        }
      } else {
        if (deviceWidth <= 768) {
          $("body").css("top", "-" + menuTop + "px");
        }
        menuTop = $("#d-menu-trigger").offset().top;

        $("body").addClass("noscroll");
      }

      var toggleWidth = $("#d-menu-trigger").hasClass("open") ? "0px" : "95vw";
      var top = $(".top-header").height();
      $("#d-navigation")
        .stop()
        .animate({ width: toggleWidth, "max-width": "340px" }, 200);
      $("#d-menu-trigger").toggleClass("open");
    }

    // Handle sub menu open/close
    $("#d-menu a").click(submenuHandlers);

    function submenuHandlers(e) {
      var clickedOpenMenu = $(this)
        .siblings("ul")
        .hasClass("open");
      // Close all other menus if they are open
      $("#d-menu ul").each(function() {
        $(this).removeClass("open");
      });
      // Reset all icons
      $("#d-menu li").each(function() {
        $(this)
          .children("i")
          .removeClass("icon-down-open")
          .addClass("icon-right-open");
      });
      // If clicked open menu, just preventDefault (close menu)
      if (clickedOpenMenu) {
        e.preventDefault();
      } else {
        var hasChildMenu = $(this).siblings("ul").length;
        if (hasChildMenu > 0) {
          e.preventDefault();
          var iconClicked = $(this).siblings("i").length;
          var iconElement = iconClicked > 0 ? $(this).siblings("i") : $(this);
          if (iconElement.hasClass("icon-right-open")) {
            iconElement
              .removeClass("icon-right-open")
              .addClass("icon-down-open");
          } else {
            iconElement
              .removeClass("icon-down-open")
              .addClass("icon-right-open");
          }
          $(this)
            .siblings("ul")
            .toggleClass("open");
        }
      }
    }

    // add icon-right-open to all menu items that have childs
    $("#d-menu .menu-item-has-children").each(function() {
      $(this).prepend(function() {
        return $('<i class="icon icon-right-open"></i>').click(submenuHandlers);
      });
    });

    // Close menu with a click outside it
    $(document).click(function(event) {
      if (
        !$(event.target)
          .closest("#d-navigation")
          .size() &&
        !$(event.target)
          .closest("#d-menu-trigger")
          .size()
      ) {
        if ($("#d-menu-trigger").hasClass("open")) {
          navclick();
        }
      }
    });
  }

  $.fn.scrollTo = function(target, options, callback) {
    if (typeof options == "function" && arguments.length == 2) {
      callback = options;
      options = target;
    }
    var settings = $.extend(
      {
        scrollTarget: target,
        offsetTop: 50,
        duration: 500,
        easing: "swing"
      },
      options
    );
    return this.each(function() {
      var scrollPane = $(this);
      var scrollTarget =
        typeof settings.scrollTarget == "number"
          ? settings.scrollTarget
          : $(settings.scrollTarget);
      var scrollY =
        typeof scrollTarget == "number"
          ? scrollTarget
          : scrollTarget.offset().top +
            scrollPane.scrollTop() -
            parseInt(settings.offsetTop);
      scrollPane.animate(
        { scrollTop: scrollY },
        parseInt(settings.duration),
        settings.easing,
        function() {
          if (typeof callback == "function") {
            callback.call(this);
          }
        }
      );
    });
  };
})(jQuery);
